<template>
  <div class="cont" id="contact">
    <div class="top">
      <div class="first">
        <div style="width:280px">
          <div style="font-size:15px;margin-bottom:7px"> <span >DIXCEL CHINA</span></div>
          <div style="margin-bottom:5px">地址：上海市嘉定区恒永路328弄（联东U谷）28号</div>
          <div style="margin-bottom:5px">邮编：201806</div>
          <div style="margin-bottom:5px">电话：021-6449-8413</div>
          <div style="margin-bottom:5px">传真：021-5994-6365</div>
          <div>邮箱: info@dixcel.cn</div>
        </div>
        <div style="width:1px;height:100%;background-color:#fff;margin:0 35px">
        </div>
        <div class="flex1">
          <div style="font-size:15px;margin-bottom:7px"> <span >DIXCEL JAPAN</span></div>
          <div style="margin-bottom:5px">地址：大阪府摂津市西一津屋3-3</div>
          <div style="margin-bottom:5px">邮编：566-0044</div>
          <div style="margin-bottom:5px">电话：06-6340-0121</div>
          <div style="margin-bottom:5px">传真：06-6340-0242</div>
          <div>邮箱: info@dixcel.co.jp</div>
        </div>
        <div style="width:1px;height:100%;background-color:#fff;margin:0 35px"></div>
        <div class="flex1 ">
          <div style="height:61px;display:flex;margin-bottom:18px">
            <el-image
              style="height:61px;width:61px;margin-right:18px;"
              :src="require('@/assets/image/home/home7/code.png')"
              :fit="fit">
            </el-image>
            <el-image
              style="height:47px;width:124px;"
              :src="require('@/assets/image/home/home7/info.png')"
              :fit="fit">
            </el-image>
            <!-- <img src="~@/assets/image/home/home7/code.png" alt="" style="height:61px;width:61px;margin-right:18px">
            <img src="~@/assets/image/home/home7/info.png" alt="" style="height:47px;width:124px;"> -->
          </div>

          <div style="height:25px;width:204px;display:flex;border:1px solid #fff;cursor:pointer" @click="weiborouter">
            <el-image
              style="height:18px;width:21px;margin:3px 7px 4px 8px;"
              :src="require('@/assets/image/home/home7/weiboLOGO.png')"
              :fit="fit">
            </el-image>
            <el-image
              style="height:11px;width:101px;margin:7px 12px 7px 0px;"
              :src="require('@/assets/image/home/home7/weibotext.png')"
              :fit="fit"

              >
            </el-image>
            <div style="width:49px;height:18px;margin:3px 6px 4px 0px;background-color:#fff;text-align:center;line-height:18px;color:#000">
              +加关注
            </div>
          </div>

        </div>
      </div>
      <div class="second">
        © 迪库盛贸易(上海)有限公司版权所有
        <span class="item" style="margin : 0 10px" @click="beianmiit">沪ICP备19041654号</span>
        <span style="margin:0 3px">|</span>
        <span class="item" style="margin : 0 10px" @click="beian">沪公网安备31011402002302号</span>
        <!-- <span style="margin:0 3px">|</span> 版本说明 <span style="margin:0 3px">|</span> 法律声明 <span style="margin:0 3px">|</span> 数据保护声明 <span style="margin:0 3px">|</span> Cookie 政策 <span style="margin:0 3px">|</span> RSS -->
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
export default {
  name: "Cont_Bottom" ,
  data() {
    return {
      fit:  'cover' ,
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width:1003px;
  height:223px;
  background-color: black;
  color: #fff;
  margin: 0 auto;

}
.top{
  padding : 37px 70px 0;
  box-sizing : border-box
  height : 213px ;
}
 .first{
    display : flex;
    height : 110px ;
    font-size:10px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
    margin-bottom:38px;
 }
 .second{
    font-size:10px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
    text-align center
 }


.bottom{
  background-color : #f90000 ;
  height : 10px;
}

.flex1{
  flex : 1
}
.item:hover{
  color : #f90000
  font-style  : normal ;
  cursor pointer
}
</style>
